/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Status_FailedInputs */

const en_tasks_status_failed = /** @type {(inputs: Tasks_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

const fr_tasks_status_failed = /** @type {(inputs: Tasks_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec`)
};

const ms_sg2_tasks_status_failed = /** @type {(inputs: Tasks_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Tasks_Status_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_status_failed = /** @type {((inputs?: Tasks_Status_FailedInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Status_FailedInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_status_failed(inputs)
	if (locale === "fr") return fr_tasks_status_failed(inputs)
	return ms_sg2_tasks_status_failed(inputs)
});